module.exports = __webpack_public_path__ + "static/media/hqm_sensitivity.2a59328c.csv";